import ReportTypeScreen from "../../Components/Reports/ReportTypeScreen";

function ReportedPosts() {
  return <ReportTypeScreen reportType="post" />;
}

export default ReportedPosts;
